import { render, staticRenderFns } from "./Grope.vue?vue&type=template&id=5023993c&scoped=true&"
import script from "./Grope.vue?vue&type=script&lang=js&"
export * from "./Grope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023993c",
  null
  
)

export default component.exports